import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import componentSection from '../../../../LeftPane/componentSection';
import titleToSectionKey from '../../../../../../../../../store/helpers/titleToSectionKeyDict';
import {
  Overlay,
  OrganizationDetailsWrapper,
  OrganizationChildren,
} from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/organizationDetails';
import { Label } from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/arrayItems';
import CollapseButton from './collapseButton';

const OrganizationDetails = (props) => {
  const { nodeProps, dragType, showImage } = props;
  const { editor, node, attributes, children } = nodeProps;
  const sectionTitle = componentSection[node.type];
  const sectionKey = titleToSectionKey[sectionTitle];

  const {
    [sectionKey]: { document: currentDocument },
  } = props;

  const { key: organizationDetailsKey } = node;

  const organizationNode = currentDocument.getParent(organizationDetailsKey);

  const organizationData = organizationNode && organizationNode.data;

  const organizationDataJSON = organizationData && organizationData.toJSON();

  const isCollapseChildren =
    (organizationDataJSON && organizationDataJSON.isCollapseChildren) || false;

  return (
    <>
      <Overlay dragType={dragType} />
      <OrganizationDetailsWrapper
        {...attributes}
        nodeType={node.type}
        isCollapseChildren={isCollapseChildren}
      >
        <OrganizationChildren showImage={showImage} nodeType={node.type}>
          {children}
        </OrganizationChildren>
        <CollapseButton
          node={node}
          editor={editor}
          isCollapseChildren={isCollapseChildren}
        />
        {node.type === 'skill_organization_details' && (
          <Label
            isCollapseChildren={isCollapseChildren}
            contentEditable={false}
          >
            Skills
          </Label>
        )}
      </OrganizationDetailsWrapper>
    </>
  );
};

OrganizationDetails.propTypes = {
  nodeProps: propTypes.objectOf(propTypes.object).isRequired,
  attributes: propTypes.objectOf(propTypes.string).isRequired,
  editor: propTypes.shape({
    resolveController: propTypes.func.isRequired,
  }).isRequired,
  userResumePreferences: propTypes.objectOf(propTypes.object).isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const {
    nodeProps: {
      node: { type },
    },
  } = ownProps;
  const sectionTitle = componentSection[type];
  const sectionKey = titleToSectionKey[sectionTitle];

  return {
    [sectionKey]: state.editResumeFormReducer[sectionKey], // re-renders organization details when there is an update in rolesCount properties
    userResumePreferences: state.editResumeFormReducer.userPreferences,
    dragType: state.editResumeFormReducer.dragType,
    collapse: state.editResumeFormReducer.collapse,
  };
};

export default connect(mapStateToProps)(OrganizationDetails);
